import {
    EditablePageBlock,
    EditablePageBlockProps,
} from "./editable-page-block";
import { NotebookPageContentBlock } from "constants/notebooks/notebook-page-content-blocks";
import React, { useMemo } from "react";
import { CodeReferenceBlock } from "../block-types/code-reference-block";
import { ChecklistBlock } from "../block-types/checklist-block";

export interface PageBlockProps
    extends Omit<EditablePageBlockProps, "additionalBlockData"> {
    draggingBlockId?: number;
    onDeactivateBlock: () => void;
}

const BLOCK_TYPE_TO_BLOCK_COMPONENT_MAP: Record<
    NotebookPageContentBlock,
    React.FC<PageBlockProps>
> = {
    [NotebookPageContentBlock.Text]: EditablePageBlock,
    [NotebookPageContentBlock.CodeReference]: CodeReferenceBlock,
    [NotebookPageContentBlock.Checklist]: ChecklistBlock,
    [NotebookPageContentBlock.Image]: EditablePageBlock,
};

export const PageBlock = (props: PageBlockProps): JSX.Element => {
    const BlockComponent = useMemo(
        () => BLOCK_TYPE_TO_BLOCK_COMPONENT_MAP[props.block.type],
        [props.block.type]
    );

    return (
        <BlockComponent
            {...props}
            onDeactivateBlock={props.onDeactivateBlock}
        />
    );
};
